const { default: profile } = require("@/config/profile");

export const calculateYearsOfExperience = () => {
  if (!profile?.experiences?.length) return 0;
  const startYear = parseInt(
    profile.experiences[profile.experiences.length - 1].year
  );
  const currentYear = new Date().getFullYear();
  return currentYear - startYear || 1;
};
